export default __webpack_public_path__ + "static/media/ic-video.5d93f3e7.svg";